import axios from "axios";

import { IP } from "../utils/Host";


export function updatePrzeniesWykonanieDoInnejGrupy(global_id_wykonania,grupa_id_drop,fechparametryTechnologii, ostatnie_wykonania,zamowienie_id,generujPolaczenia) {

// id = procesor id
console.log(global_id_wykonania)
console.log(grupa_id_drop)
console.log(ostatnie_wykonania)

  axios.get(IP + "updatePrzeniesWykonanieDoInnejGrupy/"+global_id_wykonania+"/"+grupa_id_drop+"/"+ostatnie_wykonania)
    .then((res) => {

      
      let technologia_id =res.data[0].technologia_id
    console.log("Zmiana grupy: ", res.data)
    console.log("ostatnie_wykonania: "+ostatnie_wykonania)
    fechparametryTechnologii(zamowienie_id,technologia_id)

return technologia_id

    })    .then((technologia_id) => {
generujPolaczenia( technologia_id)
    });
}


